/*
 * MyFlowers · атрибуция «одна покупка = один источник» (v4, 01.10.2026)
 * Файл темы: assets/mf-attribution.js (заменяет v3.1 целиком, вместе с правками Алёны).
 *
 * ГЛАВНОЕ В v4: правила больше не зашиты в код. Они лежат в настройке магазина
 * (метаполе магазина mf_attr.config, тип JSON) и подставляются в страницу одной строкой
 * в layout/theme.liquid ПЕРЕД подключением этого файла:
 *
 *   <script>window.MF_ATTR_CONFIG = {{ shop.metafields.mf_attr.config.value | json }};</script>
 *
 * Нет метаполя / оно пустое / в нём ошибка → работают встроенные правила ниже
 * (они повторяют v3.1 один в один, кроме исправлений из списка). Новый источник
 * (TikTok, Pinterest, блогер, партнёрка) добавляется правкой метаполя, без программиста.
 *
 * ЧТО ОСТАЛОСЬ КАК В v3.1 (на это опираются пиксель v7.3, Flow «Клуб → Meta» v3.3
 * и выгрузка в Google Ads):
 *   - все атрибуты корзины и их формат: _mf_ua, _mf_fbc, _mf_fbp, _mf_touches, _mf_visits,
 *     _mf_winner, _mf_winner_nb, _mf_winner_ad, _mf_scores;
 *   - очки, окна, правило «нет рекламного визита → none_paid», ничья → последний;
 *   - правки Алёны: отметка корзины перед подсчётом в prepareCheckout и проверка
 *     «корзина пуста → на загрузке страницы не пишем».
 *
 * ПРАВКИ РАЗРАБОТКИ К v4 (MFS-5803) — при замене файла перенести в новую версию:
 *   - openOrContinueVisit: после переадресации сплита тем Intelligems продолжает визит,
 *     открытый ещё на странице до неё (window.__mfAbEntry из snippets/ab-redirect-referrer.liquid).
 *
 * ЧТО НОВОГО В v4:
 *   1) правила из метаполя (см. DEFAULTS) + атрибут _mf_v = «4/<версия настройки>»,
 *      по нему в заказе видно, какая версия кода и настроек считала источник;
 *   2) метка без правила записывается своим именем (utm_source=shop_app → «shop_app»),
 *      раньше было общее «other»; учитывается utm_medium (email/sms, affiliate,
 *      influencer, social/organic у ссылок Facebook/Instagram из профиля);
 *   3) реферер — точное совпадение домена: trustpilot.com, partnerboost.com, oh-my-bot.com
 *      больше не считаются соцсетью (их ловило «t.co»), Gmail в Android (com.google.android.gm)
 *      — почта, а не поиск; gemini.google.com — ИИ, а не поиск; сайты купонов — «coupon»;
 *   4) новые метки клика: epik (Pinterest), ScCid (Snapchat), twclid (X), li_fat_id (LinkedIn),
 *      rdt_cid (Reddit) — записываются в касания так же, как fbclid/gclid;
 *   5) запасной вариант по cookie: если в адресе не было метки клика, а cookie Meta (_fbc)
 *      или Google (_gcl_aw / _gcl_gb) говорит о клике за последние 60 минут, которого нет
 *      в истории, — касание записывается с пометкой utm_content = «mf_cookie»;
 *   6) если браузер не даёт писать в localStorage, история держится в памяти страницы
 *      (лендинг клуба — одна страница до оплаты, этого хватает).
 *
 * ФОРМАТЫ
 *   Касание: [время_мс, тип_метки, метка, utm_source, utm_campaign, utm_content, страница,
 *             номер_объявления, utm_medium (v4)]
 *   Визит:   [начало, источник, кампания, первый, товар, корзина, страниц, активных_сек,
 *             прокрутка_%, конец, наследник, номер_объявления]
 *
 * ПРАВИЛА: ничего чужого не удаляет, атрибуты лендинга имеют приоритет, любая ошибка
 * глушится — файл не имеет права ломать корзину и оформление. Перехват fetch/XHR только
 * СМОТРИТ адрес запроса (/cart/add) и отдаёт оригинальный запрос без изменений.
 */
(function () {
  'use strict';
  if (window.MFAttribution) return;

  // ---------- встроенные правила (= v3.1 + исправления v4) ----------
  var DEFAULTS = {
    v: 'default',
    // Метка клика в адресе → площадка. Порядок важен: берётся первая найденная.
    clickIds: [
      ['fbclid', 'meta'], ['gclid', 'google'], ['gbraid', 'google'], ['wbraid', 'google'],
      ['ttclid', 'tiktok'], ['msclkid', 'bing'],
      ['epik', 'pinterest'], ['ScCid', 'snapchat'], ['twclid', 'x'], ['li_fat_id', 'linkedin'], ['rdt_cid', 'reddit'],
    ],
    // Касание без метки клика: [шаблон utm_source, шаблон utm_medium, источник].
    // Пустой шаблон = любое значение. Первое совпадение побеждает. Регистр не важен.
    utm: [
      ['', '^(influencer|blogger|ugc|creator)$', 'blogger'],
      ['^(facebook|fb|instagram|ig|meta)\\b', '^(organic|social|bio|profile|post|story)$', 'social'],
      ['^(facebook|fb|instagram|ig|meta)\\b', '', 'meta'],
      ['google', '', 'google'],
      ['tiktok', '', 'tiktok'],
      ['bing|microsoft', '', 'bing'],
      ['mindbox|maestra|shopify_email|klaviyo|email|newsletter', '', 'email'],
      ['awin|affiliate', '', 'affiliate'],
      ['chatgpt|openai|perplexity|copilot|gemini|claude', '', 'ai'],
      ['pinterest', '^(cpc|ppc|paid|paid_social)$', 'pinterest'],
      ['snapchat', '^(cpc|ppc|paid|paid_social)$', 'snapchat'],
      ['pinterest|threads|snapchat|linkedin|twitter|^x$|reddit|youtube|telegram', '', 'social'],
      ['', '^(e-?mail|sms|newsletter)$', 'email'],
      ['', '^affiliate', 'affiliate'],
      ['', 'social', 'social'],
    ],
    // Платные площадки: только они могут «забрать» покупку. Нет ни одного визита с них → none_paid.
    paid: ['meta', 'google', 'tiktok', 'bing'],
    pts: { base: 1, first: 3, product: 2, cart: 4, engaged: 1 },
    engagedPages: 4,
    engagedSec: 120,
    visitGapMin: 30, // визит заканчивается после 30 мин бездействия
    inheritMin: 60, // прямой заход ≤60 мин после рекламы = её продолжение
    pathDays: 30, // окно пути
    touchDays: 60, // сколько хранить касания
    fbcDays: 90,
    cookieFallbackMin: 60, // 0 = выключить запасной вариант по cookie
    ref: {
      internal: ['myflowers.co.uk', 'shopify.com', 'myshopify.com', 'shop.app', 'paypal.com', 'paypal.me', 'paypalobjects.com',
        'stripe.com', 'link.com', 'klarna.com', 'klarna.co.uk', 'pay.google.com', 'cardinalcommerce.com', 'arcot.com'],
      ai: ['chatgpt.com', 'chat.openai.com', 'openai.com', 'perplexity.ai', 'copilot.microsoft.com', 'gemini.google.com', 'claude.ai'],
      email: ['mail.google.com', 'outlook.live.com', 'outlook.office.com', 'outlook.office365.com', 'mail.yahoo.com', 'mail.aol.com',
        'mail.ru', 'deref-gmx.com', 'email.bt.com', 'mail.qq.com', 'inbox.lv'],
      search: ['bing.com', 'duckduckgo.com', 'ecosia.org', 'yahoo.com', 'yandex.ru', 'yandex.com', 'yandex.kz', 'yandex.com.tr', 'ya.ru',
        'baidu.com', 'startpage.com', 'search.brave.com', 'nortonsafesearch.com'],
      social: ['facebook.com', 'fb.com', 'fb.me', 'messenger.com', 'instagram.com', 't.co', 'twitter.com', 'x.com', 'tiktok.com',
        'pinterest.com', 'pinterest.co.uk', 'pin.it', 'reddit.com', 'youtube.com', 'youtu.be', 'linkedin.com', 'lnkd.in',
        'threads.net', 'threads.com', 'snapchat.com', 't.me', 'telegram.org', 'twitch.tv'],
      coupon: ['vouchercodes.co.uk', 'vouchercloud.com', 'groupon.co.uk', 'topcashback.co.uk', 'quidco.com', 'latestdeals.co.uk',
        'hotukdeals.com', 'bluelightcard.co.uk', 'easyfundraising.org.uk', 'savoo.co.uk', 'savoo.com', 'hotpromocode.co.uk',
        'fatcoupon.com', 'completesavings.co.uk', 'rebatesme.com', 'couponchief.com', 'voucherhood.co.uk', 'emucoupon.com',
        'couponcause.com', 'wethrift.com', 'coupert.com', 'dontpayfull.com', 'lovediscountvouchers.co.uk', 'nhsdiscounts.org.uk',
        'thediscountbook.com', 'grabasaving.com', 'maxrebates.com', 'collectoffers.com', 'unisonrewards.com', 'nxrewards.com'],
      map: {}, // свои домены: { "blog.example.com": "blogger" }
    },
    // Переход из приложения Android (реферер android-app://пакет)
    apps: {
      'com.google.android.gm': 'email',
      'com.google.android.googlequicksearchbox': 'organic',
      'com.google.android.apps.searchlite': 'organic',
      'com.facebook.katana': 'social',
      'com.facebook.orca': 'social',
      'com.instagram.android': 'social',
      'com.pinterest': 'social',
      'com.zhiliaoapp.musically': 'social',
      'com.snapchat.android': 'social',
      'org.telegram.messenger': 'social',
      'com.whatsapp': 'social',
      'com.microsoft.office.outlook': 'email',
    },
  };

  var RESERVED = { none_paid: 1, direct: 1, organic: 1, referral: 1 };

  function merge(base, over) {
    if (!over || typeof over !== 'object' || Array.isArray(over)) return base;
    var out = {};
    for (var k in base) if (Object.prototype.hasOwnProperty.call(base, k)) out[k] = base[k];
    for (var j in over) {
      if (!Object.prototype.hasOwnProperty.call(over, j)) continue;
      var b = base[j], o = over[j];
      out[j] = b && typeof b === 'object' && !Array.isArray(b) && o && typeof o === 'object' && !Array.isArray(o) ? merge(b, o) : o;
    }
    return out;
  }

  function num(v, d) { var n = Number(v); return isFinite(n) && n >= 0 ? n : d; }

  var CFG = DEFAULTS;
  try { CFG = merge(DEFAULTS, window.MF_ATTR_CONFIG); } catch (e) { CFG = DEFAULTS; }

  // Шаблоны из настройки собираем один раз; битый шаблон пропускаем, а не падаем.
  function rx(s) { try { return s ? new RegExp(String(s), 'i') : null; } catch (e) { return false; } }
  var UTM_RULES = [];
  try {
    (Array.isArray(CFG.utm) ? CFG.utm : DEFAULTS.utm).forEach(function (r) {
      if (!Array.isArray(r) || !r[2]) return;
      var s = rx(r[0]), m = rx(r[1]);
      if (s === false || m === false) return;
      UTM_RULES.push([s, m, String(r[2]).toLowerCase()]);
    });
  } catch (e) {}
  var CLICK_IDS = [], CLICK_SRC = {};
  try {
    (Array.isArray(CFG.clickIds) ? CFG.clickIds : DEFAULTS.clickIds).forEach(function (c) {
      if (Array.isArray(c) && c[0] && c[1]) { CLICK_IDS.push(String(c[0])); CLICK_SRC[String(c[0])] = String(c[1]).toLowerCase(); }
    });
  } catch (e) {}
  var PAID = {};
  try { (Array.isArray(CFG.paid) ? CFG.paid : DEFAULTS.paid).forEach(function (p) { PAID[String(p).toLowerCase()] = 1; }); } catch (e) {}
  var PTS = merge(DEFAULTS.pts, CFG.pts),
    REF = CFG.ref && typeof CFG.ref === 'object' ? CFG.ref : DEFAULTS.ref,
    APPS = CFG.apps && typeof CFG.apps === 'object' ? CFG.apps : DEFAULTS.apps;

  var LS_TOUCHES = 'mf_touches',
    LS_FBC = 'mf_fbc',
    LS_VISITS = 'mf_visits',
    SS_SENT = 'mf_attr_sent',
    MAX_TOUCHES = 10,
    MAX_VISITS = 12,
    MIN = 60 * 1e3,
    DAY = 24 * 3600 * 1e3,
    TTL_MS = num(CFG.touchDays, 60) * DAY,
    FBC_TTL_MS = num(CFG.fbcDays, 90) * DAY,
    UTM_DEDUP_MS = 30 * MIN,
    VISIT_GAP_MS = num(CFG.visitGapMin, 30) * MIN,
    INHERIT_MS = num(CFG.inheritMin, 60) * MIN,
    PATH_MS = num(CFG.pathDays, 30) * DAY,
    COOKIE_MS = num(CFG.cookieFallbackMin, 60) * MIN,
    ENGAGED_PAGES = num(CFG.engagedPages, 4),
    ENGAGED_SEC = num(CFG.engagedSec, 120),
    ACTIVE_IDLE_MS = 30 * 1e3,
    VERSION = '4/' + String(CFG.v || 'default').slice(0, 20);

  // v4: если хранилище недоступно, держим значения в памяти страницы.
  var MEM = { local: {}, session: {} };
  function store(kind, key, value) {
    if (value === void 0) {
      try {
        var got = (kind === 'local' ? window.localStorage : window.sessionStorage).getItem(key);
        if (got !== null) return got;
      } catch (e) {}
      return Object.prototype.hasOwnProperty.call(MEM[kind], key) ? MEM[kind][key] : null;
    }
    MEM[kind][key] = value;
    try { (kind === 'local' ? window.localStorage : window.sessionStorage).setItem(key, value); } catch (e) {}
    return null;
  }

  function cookie(name) {
    try {
      for (var parts = document.cookie ? document.cookie.split('; ') : [], i = 0; i < parts.length; i++) {
        var eq = parts[i].indexOf('=');
        if (parts[i].slice(0, eq) === name) return decodeURIComponent(parts[i].slice(eq + 1));
      }
    } catch (e) {}
    return '';
  }

  function readTouches() {
    try {
      var list = JSON.parse(store('local', LS_TOUCHES) || '[]'),
        now = Date.now();
      return Array.isArray(list) ? list.filter(function (t) { return t && now - t[0] < TTL_MS; }) : [];
    } catch (e) {
      return [];
    }
  }

  function saveTouch(touch) {
    var list = readTouches();
    list.push(touch);
    if (list.length > MAX_TOUCHES) list = list.slice(-MAX_TOUCHES);
    store('local', LS_TOUCHES, JSON.stringify(list));
    if (touch[1] === 'fbclid') store('local', LS_FBC, 'fb.1.' + touch[0] + '.' + touch[2]);
  }

  function recordTouch() {
    try {
      for (var q = new URLSearchParams(window.location.search), cid = '', cv = '', i = 0; i < CLICK_IDS.length; i++) {
        var v = q.get(CLICK_IDS[i]);
        if (v) { cid = CLICK_IDS[i]; cv = v.slice(0, 200); break; }
      }
      var src = (q.get('utm_source') || '').slice(0, 60);
      if (!cid && !src) return null;
      var campaign = (q.get('utm_campaign') || '').slice(0, 80),
        content = (q.get('utm_content') || '').slice(0, 60),
        adId = String(q.get('ad_id') || q.get('tw_adid') || '').replace(/\D/g, '').slice(0, 25),
        medium = (q.get('utm_medium') || '').replace(/[",\[\]]/g, '').slice(0, 30),
        page = window.location.pathname.slice(0, 80),
        now = Date.now(),
        list = readTouches();
      var touch = [now, cid, cv, src, campaign, content, page, adId, medium];
      if (
        (cv && list.some(function (t) { return t[2] === cv; })) ||
        (!cv && list.some(function (t) {
          return !t[2] && t[3] === src && t[4] === campaign && t[5] === content && t[6] === page && now - t[0] < UTM_DEDUP_MS;
        }))
      )
        return null; // тот же клик (перезагрузка страницы) — не новое касание
      saveTouch(touch);
      return touch;
    } catch (e) {
      return null;
    }
  }

  // v4: клик, который видит cookie площадки, но не видели мы (метку вырезали из адреса,
  // хранилище очистили). Только свежий (≤60 мин), только если его нет в истории
  // и он новее начала последнего визита.
  function cookieTouch() {
    try {
      if (!COOKIE_MS) return null;
      var now = Date.now(), best = null, c, p;
      c = cookie('_fbc');
      p = c.split('.');
      if (p.length >= 4 && p[0] === 'fb') best = { ts: Number(p[2]) || 0, cid: 'fbclid', cv: p.slice(3).join('.') };
      [['_gcl_aw', 'gclid'], ['_gcl_gb', 'gbraid']].forEach(function (g) {
        var parts = cookie(g[0]).split('.');
        if (parts.length >= 3 && parts[0] === 'GCL') {
          var ts = (Number(parts[1]) || 0) * 1e3;
          if (!best || ts > best.ts) best = { ts: ts, cid: g[1], cv: parts.slice(2).join('.') };
        }
      });
      if (!best || !best.cv || now - best.ts > COOKIE_MS || best.ts - now > 5 * MIN) return null;
      if (!CLICK_SRC[best.cid]) return null;
      var cv = best.cv.slice(0, 200),
        touches = readTouches(),
        visits = readVisits(),
        last = visits[visits.length - 1];
      if (touches.some(function (t) { return t[2] === cv; })) return null;
      if (last && best.ts <= last[0]) return null;
      var touch = [now, best.cid, cv, '', '', 'mf_cookie', window.location.pathname.slice(0, 80), '', ''];
      saveTouch(touch);
      return touch;
    } catch (e) {
      return null;
    }
  }

  function fbcTime(fbc) { return Number(String(fbc || '').split('.')[2]) || 0; }
  function storedFbc() {
    var fbc = store('local', LS_FBC) || '',
      created = fbcTime(fbc);
    return !created || Date.now() - created > FBC_TTL_MS ? '' : fbc;
  }
  function freshestFbc() {
    var fromCookie = cookie('_fbc'),
      fromClick = storedFbc();
    return fromCookie ? (fromClick && fbcTime(fromClick) > fbcTime(fromCookie) ? fromClick : fromCookie) : fromClick;
  }

  // ---------- источник визита ----------
  function nameOf(s) {
    var n = String(s || '').toLowerCase().replace(/[^a-z0-9_.-]+/g, '_').replace(/^_+|_+$/g, '').slice(0, 30);
    if (!n) return 'other';
    return PAID[n] || RESERVED[n] ? 'u_' + n : n;
  }

  // Порядок как в v3.1: правила идут сверху вниз; метка клика срабатывает на первом
  // правиле своей площадки (fbclid — на правиле meta, gclid — на правиле google).
  // Площадка метки без своего правила (x, linkedin, reddit) — после всех правил.
  function sourceOfTouch(t) {
    var cidSrc = t[1] ? CLICK_SRC[t[1]] || '' : '',
      s = String(t[3] || ''),
      m = String(t[8] || '');
    for (var i = 0; i < UTM_RULES.length; i++) {
      var r = UTM_RULES[i];
      if (cidSrc && cidSrc === r[2]) return r[2];
      if ((r[0] || r[1]) && (!r[0] || r[0].test(s)) && (!r[1] || r[1].test(m))) return r[2];
    }
    if (cidSrc) return cidSrc;
    return nameOf(s);
  }

  // Домен совпадает точно или это его поддомен (l.facebook.com → facebook.com).
  function hostIs(host, list) {
    if (!Array.isArray(list)) return false;
    for (var i = 0; i < list.length; i++) {
      var d = String(list[i]).toLowerCase();
      if (d && (host === d || host.slice(-(d.length + 1)) === '.' + d)) return true;
    }
    return false;
  }
  function hostMap(host, map) {
    if (!map || typeof map !== 'object') return '';
    for (var d in map) {
      if (!Object.prototype.hasOwnProperty.call(map, d)) continue;
      var dd = String(d).toLowerCase();
      if (host === dd || host.slice(-(dd.length + 1)) === '.' + dd) return String(map[d]).toLowerCase();
    }
    return '';
  }

  function classifyReferrer(ref, ownHost) {
    var u = null, r = '';
    try { u = ref ? new URL(ref) : null; r = u ? u.hostname.toLowerCase() : ''; } catch (e) {}
    if (!r) return 'direct';
    if (u.protocol === 'android-app:') return String(APPS[r] || 'referral').toLowerCase();
    if (r === ownHost || hostIs(r, REF.internal) || /(^|\.)(acs|3ds|3dsecure)[a-z0-9-]*\./.test(r))
      return ''; // внутренний переход / оплата / банк 3-D Secure — не новый источник
    var own = hostMap(r, REF.map);
    if (own) return own;
    if (hostIs(r, REF.ai)) return 'ai';
    if (hostIs(r, REF.email) || /^(web)?mail\./.test(r)) return 'email';
    if (/(^|\.)google\.(com|co\.[a-z]{2}|com\.[a-z]{2}|[a-z]{2,3})$/.test(r) || hostIs(r, REF.search)) return 'organic';
    if (hostIs(r, REF.social)) return 'social';
    if (hostIs(r, REF.coupon)) return 'coupon';
    return 'referral';
  }
  function sourceOfReferrer() { return classifyReferrer(document.referrer || '', window.location.hostname); }

  // ---------- визиты ----------
  function readVisits() {
    try {
      var list = JSON.parse(store('local', LS_VISITS) || '[]'),
        now = Date.now();
      return Array.isArray(list) ? list.filter(function (v) { return v && now - v[0] < PATH_MS; }) : [];
    } catch (e) {
      return [];
    }
  }
  function saveVisits(list) {
    if (list.length > MAX_VISITS) list = list.slice(-MAX_VISITS);
    store('local', LS_VISITS, JSON.stringify(list));
  }

  // Новый визит открывает: рекламная метка, или переход с другого сайта (не «прямой» и не свой),
  // или 30 мин тишины. Иначе — продолжение текущего визита.
  function openOrContinueVisit(newTouch) {
    try {
      var list = readVisits(),
        now = Date.now(),
        last = list[list.length - 1],
        refSrc = newTouch ? '' : sourceOfReferrer();
      // MFS-5803: после переадресации Intelligems реферер подменён на исходный, и без этой проверки
      // визит, открытый ещё на странице до переадресации, раздвоился бы.
      var abEntry = window.__mfAbEntry,
        startedBeforeRedirect = !!(abEntry && last && last[0] >= abEntry.ts);
      var continues = last && now - last[9] < VISIT_GAP_MS && !newTouch && (startedBeforeRedirect || refSrc === '' || refSrc === 'direct');
      if (continues) {
        last[6] += 1;
        last[9] = now;
      } else {
        var src = newTouch ? sourceOfTouch(newTouch) : refSrc || 'direct';
        var campaign = newTouch ? String(newTouch[4] || '').slice(0, 40) : '';
        var heir = '', adId = newTouch ? String(newTouch[7] || '') : '';
        if (src === 'direct' && last && PAID[last[10] || last[1]] && now - last[9] <= INHERIT_MS) { heir = last[10] || last[1]; adId = String(last[11] || ''); }
        list.push([now, src, campaign, list.length === 0 ? 1 : 0, 0, 0, 1, 0, 0, now, heir, adId]);
      }
      saveVisits(list);
    } catch (e) {}
  }

  function markCurrent(field, value) {
    try {
      var list = readVisits(),
        last = list[list.length - 1];
      if (!last) return;
      if (field === 8) { if (value > last[8]) last[8] = value; }
      else if (field === 7) last[7] += value;
      else last[field] = value;
      last[9] = Date.now();
      saveVisits(list);
    } catch (e) {}
  }

  function scoreOf(v, withBonus) {
    var p = PTS.base;
    if (withBonus && v[3]) p += PTS.first;
    if (v[4]) p += PTS.product;
    if (v[5]) p += PTS.cart;
    if (v[6] >= ENGAGED_PAGES || v[7] >= ENGAGED_SEC) p += PTS.engaged;
    return p;
  }

  function winnerOf(list, withBonus) {
    var sums = {}, lastIdx = {};
    list.forEach(function (v, i) {
      var s = v[10] || v[1];
      sums[s] = (sums[s] || 0) + scoreOf(v, withBonus);
      lastIdx[s] = i;
    });
    var hasPaid = list.some(function (v) { return PAID[v[10] || v[1]]; });
    if (!hasPaid) return { winner: 'none_paid', sums: sums };
    var best = '', bestPts = -1;
    Object.keys(sums).forEach(function (s) {
      if (sums[s] > bestPts || (sums[s] === bestPts && lastIdx[s] > lastIdx[best])) { best = s; bestPts = sums[s]; }
    });
    return { winner: best, sums: sums };
  }

  function winnerAdOf(list, winner) {
    for (var i = list.length - 1; i >= 0; i--) {
      var v = list[i];
      if ((v[10] || v[1]) === winner && v[11]) return String(v[11]);
    }
    return '';
  }

  function currentAttributes() {
    var a = {};
    try {
      a._mf_v = VERSION;
      var ua = (navigator.userAgent || '').slice(0, 400);
      if (ua) a._mf_ua = ua;
      var fbc = freshestFbc();
      if (fbc) a._mf_fbc = fbc;
      var fbp = cookie('_fbp');
      if (fbp) a._mf_fbp = fbp;
      var touches = readTouches();
      if (touches.length) {
        for (var json = JSON.stringify(touches); json.length > 1800 && touches.length > 1; ) {
          touches = touches.slice(1);
          json = JSON.stringify(touches);
        }
        a._mf_touches = json;
      }
      var visits = readVisits();
      if (visits.length) {
        var w = winnerOf(visits, true),
          wnb = winnerOf(visits, false);
        a._mf_winner = w.winner;
        a._mf_winner_nb = wnb.winner;
        var wad = winnerAdOf(visits, w.winner);
        if (wad) a._mf_winner_ad = wad;
        a._mf_scores = Object.keys(w.sums).map(function (s) { return s + ':' + w.sums[s]; }).join(',').slice(0, 200);
        var vj = JSON.stringify(visits);
        for (var cut = visits; vj.length > 1800 && cut.length > 1; ) { cut = cut.slice(1); vj = JSON.stringify(cut); }
        a._mf_visits = vj;
      }
    } catch (e) {}
    return a;
  }

  function cartId(token) { return String(token || '').split('?')[0]; }

  function sendAttributes(attrs) {
    var svc = window.CartService;
    return svc && typeof svc.updateAttributes == 'function'
      ? svc.updateAttributes(attrs).then(function (res) { return res && res.data; })
      : (window.__mfOrigFetch || window.fetch)('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: attrs }),
            credentials: 'same-origin',
            keepalive: !0,
          }).then(function (r) {
            if (!r.ok) throw new Error('cart update failed: ' + r.status);
            return r.json();
          });
  }

  // Правка Алёны (v3.1): переход к оплате = положил в корзину, отмечаем ДО подсчёта победителя.
  function wrapCartService() {
    try {
      var svc = window.CartService;
      if (!svc || typeof svc.prepareCheckout != 'function' || svc.__mfWrapped) return;
      var original = svc.prepareCheckout;
      svc.prepareCheckout = function (options) {
        try {
          options = options || {};
          markCurrent(5, 1);
          var own = options.attributes || {},
            merged = currentAttributes();
          for (var k in own) if (Object.prototype.hasOwnProperty.call(own, k)) merged[k] = own[k];
          options.attributes = merged;
        } catch (e) {}
        return original.apply(this, [options].concat([].slice.call(arguments, 1)));
      };
      svc.__mfWrapped = !0;
    } catch (e) {}
  }

  // Правка Алёны (v3.1): на загрузке страницы пустую корзину не трогаем.
  function cartIsEmpty() {
    var svc = window.CartService;
    return !svc || typeof svc.getCart != 'function'
      ? Promise.resolve(!1)
      : svc.getCart().then(function (cart) { return !!cart && cart.item_count === 0; }, function () { return !1; });
  }

  function pushToCart(afterAdd) {
    try {
      var a = currentAttributes(),
        sig = JSON.stringify(a);
      if (sig === '{}' || store('session', SS_SENT) === cartId(cookie('cart')) + '|' + sig) return;
      (afterAdd ? Promise.resolve(!1) : cartIsEmpty())
        .then(function (empty) {
          if (!empty)
            return sendAttributes(a).then(function (cart) {
              store('session', SS_SENT, cartId((cart && cart.token) || cookie('cart')) + '|' + sig);
            });
        })
        .catch(function () {});
    } catch (e) {}
  }

  var pushTimer = null;
  function pushSoon() {
    try { clearTimeout(pushTimer); pushTimer = setTimeout(function () { pushToCart(!0); }, 1500); } catch (e) {}
  }

  function onCartAdd() { markCurrent(5, 1); pushSoon(); }

  function watchCartAdds() {
    try {
      var of = window.fetch;
      window.__mfOrigFetch = of ? of.bind(window) : null;
      if (of && !of.__mf) {
        var wrapped = function (input) {
          try {
            var u = typeof input === 'string' ? input : input && input.url;
            if (u && /\/cart\/add(\.js)?(\?|$)/.test(String(u))) setTimeout(onCartAdd, 0);
          } catch (e) {}
          return of.apply(this, arguments);
        };
        wrapped.__mf = 1;
        window.fetch = wrapped;
      }
      var xo = XMLHttpRequest.prototype.open;
      if (!xo.__mf) {
        var xw = function (m, u) {
          try { if (u && /\/cart\/add(\.js)?(\?|$)/.test(String(u))) setTimeout(onCartAdd, 0); } catch (e) {}
          return xo.apply(this, arguments);
        };
        xw.__mf = 1;
        XMLHttpRequest.prototype.open = xw;
      }
      document.addEventListener('submit', function (e) {
        try { var act = e.target && e.target.getAttribute('action'); if (act && /\/cart\/add/.test(act)) onCartAdd(); } catch (er) {}
      }, true);
    } catch (e) {}
  }

  function watchEngagement() {
    try {
      if (/^\/products\//.test(window.location.pathname)) markCurrent(4, 1);
      var lastAct = Date.now(), maxScroll = 0;
      var act = function () { lastAct = Date.now(); };
      ['mousemove', 'keydown', 'touchstart', 'click'].forEach(function (ev) { document.addEventListener(ev, act, { passive: true }); });
      window.addEventListener('scroll', function () {
        act();
        try {
          var h = document.documentElement, b = document.body,
            full = Math.max(h.scrollHeight, b ? b.scrollHeight : 0) - window.innerHeight;
          var pct = full > 0 ? Math.min(100, Math.round((window.scrollY / full) * 100)) : 100;
          if (pct > maxScroll + 4) { maxScroll = pct; markCurrent(8, pct); }
        } catch (e) {}
      }, { passive: true });
      var acc = 0;
      setInterval(function () {
        try {
          if (document.visibilityState === 'visible' && Date.now() - lastAct < ACTIVE_IDLE_MS) {
            acc += 5;
            if (acc >= 15) { markCurrent(7, acc); acc = 0; }
          }
        } catch (e) {}
      }, 5000);
      window.addEventListener('pagehide', function () { try { if (acc) markCurrent(7, acc); acc = 0; } catch (e) {} });
    } catch (e) {}
  }

  // ---------- запуск ----------
  var newTouch = recordTouch() || cookieTouch();
  openOrContinueVisit(newTouch);
  watchCartAdds();
  watchEngagement();
  wrapCartService();

  function init() { wrapCartService(); pushToCart(); }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();

  window.MFAttribution = {
    version: 4,
    config: CFG.v || 'default',
    attributes: currentAttributes,
    touches: readTouches,
    visits: readVisits,
    winner: function () { var v = readVisits(); return v.length ? winnerOf(v, true) : null; },
    classify: function (t) { return Array.isArray(t) ? sourceOfTouch(t) : classifyReferrer(String(t || ''), window.location.hostname); },
  };
})();
